import { takeLatest, put, call, all, select } from 'redux-saga/effects';
import get from 'lodash/get';
import { getMessageContentNew } from 'yoda-interfaces/lib/Content/ContentApi';
import {
    GET_PROMOTIONAL_SIGNUP_CONTENT_ERROR,
    GET_PROMOTIONAL_SIGNUP_CONTENT_REQUEST,
    GET_PROMOTIONAL_SIGNUP_CONTENT_SUCCESS,
} from '../actionTypes/PromotionalSignUpActionTypes';

const context = (state) => state.context;

export function* getPromotionalSignUpContent() {
    const appContext = yield select(context);
    const { enableCoreMediaContent = true } = appContext?.featureFlags || {};
    try {
        const actionForContent = {
            payload: {
                skipExtractUIContent: true,
                searchTerm: 'cf-promotional-signup',
                supportMultiZoneData: true,
            },
        };
        const { supportMultiZoneData } = actionForContent.payload;
        const modifyAction = actionForContent;
        modifyAction.payload = actionForContent.payload;
        if (enableCoreMediaContent) {
            actionForContent.isCMHeaderRequired = true;
            actionForContent.payload.skipExtractUIContent = false;
        }
        let components = yield call(getMessageContentNew, actionForContent, supportMultiZoneData);
        if (!enableCoreMediaContent && components.length > 0) {
            const data = {
                imageSection: get(components, '[0].content.html', ''),
                headerSection: get(components, '[1].content.html', ''),
                agreementSection: get(components, '[2].content.html', ''),
                TermsSection: get(components, '[3].content.html', ''),
                subTitleSection: get(components, '[4].content.html', ''),
            };
            yield put({ type: GET_PROMOTIONAL_SIGNUP_CONTENT_SUCCESS, payload: { data } });
            return;
        }
        if (enableCoreMediaContent && components.status === 200) {
            const data = {
                imageSection: get(components, 'body[0]', ''),
                headerSection: get(components, 'body[1]', ''),
                agreementSection: get(components, 'body[2]', ''),
                TermsSection: get(components, 'body[3]', ''),
                subTitleSection: get(components, 'body[4]', ''),
            };
            yield put({ type: GET_PROMOTIONAL_SIGNUP_CONTENT_SUCCESS, payload: { data } });
            return;
        }
        if (enableCoreMediaContent && components.status !== 200) {
            actionForContent.isCMHeaderRequired = false;
            actionForContent.payload.skipExtractUIContent = true;
            components = yield call(getMessageContentNew, actionForContent);
            const data = {
                imageSection: get(components, '[0].content.html', ''),
                headerSection: get(components, '[1].content.html', ''),
                agreementSection: get(components, '[2].content.html', ''),
                TermsSection: get(components, '[3].content.html', ''),
                subTitleSection: get(components, '[4].content.html', ''),
            };
            yield put({ type: GET_PROMOTIONAL_SIGNUP_CONTENT_SUCCESS, payload: { data } });
            return;
        }
        const error = {
            errorCode: 'NO_PROMOTIONAL_SIGNUP_COMPONENTS_RETURNED_FROM_SERVICE',
            message: 'No content components returned from IRIS service',
        };
        throw error;
    } catch (err) {
        const error = {
            errorMessage: err.message,
            errorCode: err.errorCode || 'EXCEPTION_IN_GET_PROMOTIONAL_SIGNUP_CONTENT_SAGA',
        };
        const errorPayload = {
            error,
        };

        yield all([
            put({
                type: GET_PROMOTIONAL_SIGNUP_CONTENT_ERROR,
                payload: errorPayload,
            }),
        ]);
    }
}

export default function* watchPromotionalSignUp() {
    yield takeLatest(GET_PROMOTIONAL_SIGNUP_CONTENT_REQUEST, getPromotionalSignUpContent);
}

watchPromotionalSignUp.sagaName = 'promotionalSignUp';
